export type PsychomotorDevelopmentType =
  | 'age-compatible'
  | 'social-smile'
  | 'head-support'
  | 'independent-walking'
  | 'speech'
  | 'school-performance';

export type PsychomotorDevelopmentItem = {
  id?: string;
  type: PsychomotorDevelopmentType;
  value: boolean | null; // null means not answered, true = yes, false = no
  observations: string; // παρατηρήσεις
};

export const PSYCHOMOTOR_DEVELOPMENT_TYPES: PsychomotorDevelopmentType[] = [
  'age-compatible',
  'social-smile',
  'head-support',
  'independent-walking',
  'speech',
  'school-performance',
];
